import { Sparkles, Smartphone, Wand2, Search, Layers, Shield } from "lucide-react";

const benefits = [
  { icon: Sparkles, text: "Free access during beta" },
  { icon: Smartphone, text: "Mobile-first design — capture ideas anywhere" },
  { icon: Wand2, text: "AI-generated titles — just dump the thought, we'll name it" },
  { icon: Search, text: "Full search across all your ideas" },
  { icon: Layers, text: "Simple organization: active, archived, or searching" },
  { icon: Shield, text: "Secure authentication — your ideas stay private" },
];

const BenefitsSection = () => {
  return (
    <section className="section-padding bg-muted/30">
      <div className="section-container">
        <h2 className="text-sm font-semibold uppercase tracking-widest text-primary mb-8">
          What You Get (Early Access)
        </h2>
        
        <div className="grid sm:grid-cols-2 gap-4">
          {benefits.map((benefit) => (
            <div
              key={benefit.text}
              className="flex items-center gap-3 p-4 rounded-lg bg-card/50 border border-border/30"
            >
              <benefit.icon className="w-5 h-5 text-primary flex-shrink-0" />
              <span className="text-foreground">{benefit.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
